/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CODE SELECTOR : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	codeselector: {
		'& .codepiece': {
			marginBottom: pxToEm(20),
			'&:last-child': { marginBottom: '0' },
			'& p': {
				fontSize: pxToEm(14),
				marginBottom: pxToEm(3),
				'& .highlight': { color: theme.color.primary.medium.swatch }
			},
			'& .group': {
				display: 'flex',
				alignItems: 'center',
				'& .field': {
					flex: '1 0 auto'
				},
				'& .button': {
					flex: replacePXinStringWithEM('0 0 87px'),
					fontSize: pxToEm(14),
					width: 'auto',
					height: pxToEm(53)
				}
			}
		}
	}
});